import { animate, state, style, transition, trigger } from '@angular/animations'
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  inject,
  QueryList,
} from '@angular/core'
import { MixpanelService } from '@src/app/core/services/analytics/mixpanel.service.js'
import { AccordionItemDirective } from './accordion-item.directive.js'

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('contentExpansion', [
      state('expanded', style({ height: '*', opacity: 1, visibility: 'visible' })),
      state(
        'collapsed',
        style({ height: '0px', opacity: 0, visibility: 'hidden', display: 'none' }),
      ),
      transition('expanded <=> collapsed', animate('200ms ease-in')),
    ]),
    trigger('headerIconToggle', [
      state('expanded', style({ transform: 'rotate(0deg)' })),
      state('collapsed', style({ transform: 'rotate(-180deg)' })),
      transition('expanded <=> collapsed', animate('200ms ease-in')),
    ]),
  ],
  standalone: false,
})
export class AccordionComponent {
  private mixPanelService = inject(MixpanelService)
  expanded = new Set<number>()
  @ContentChildren(AccordionItemDirective) items!: QueryList<AccordionItemDirective>

  public toggle(): void {}
  public toggleAccordionState(index: number): void {
    if (this.expanded.has(index)) {
      this.expanded.delete(index)
      this.mixPanelService.trackEvent('expandAccordionState')
    } else this.expanded.add(index)
  }

  protected generateContext(item: AccordionItemDirective, i: number): any {
    return { $implicit: item, index: i, toggle: () => this.toggleAccordionState(i) }
  }
}
